import BreakpointMenu from './BreakpointMenu';
import { BreakpointMenuProps, BreakpointMenuValueProps } from './types';

export type { BreakpointMenuProps, BreakpointMenuValueProps };
export default BreakpointMenu;
